import { ITableCell } from '@tecalisdev/infinity';
import { TranslateService } from '@ngx-translate/core';
import { buildDocumentSecondaryLabel, notAvailableLabel } from './utils';

export type IdentityCellDocumentRow = {
	document_number?: string | null;
	document_type?: string | null;
	nationality?: string | null;
};

/**
 * Shared document identity cell for process list / panel process tables (NIF-846).
 * `resolveDocumentTypeLabel` should use MasterService.getDocumentTypeLabel when available.
 */
export function buildIdentityCell(
	row: IdentityCellDocumentRow,
	trans: TranslateService,
	resolveDocumentTypeLabel: (documentType: string) => string,
): ITableCell {
	const documentNumber = row.document_number?.trim();
	if (!documentNumber) {
		return { label: notAvailableLabel(trans) };
	}

	const empty = notAvailableLabel(trans);
	const documentTypeLabel = row.document_type
		? resolveDocumentTypeLabel(row.document_type)
		: row.document_type || empty;

	return {
		label: documentNumber,
		secondaryLabel: buildDocumentSecondaryLabel(row.document_type, row.nationality, documentTypeLabel),
	};
}
